import { StateType } from 'typesafe-actions';
import availableServicesReducer from 'store/availableServices/reducer';
import buildingReducer from 'store/building/reducer';
import cartReducer from 'store/cart/reducer';
import { combineReducers } from 'redux';
import configReducer from 'store/config/reducer';
import errorsReducer from 'store/errors/reducer';
import featureFlagsReducer from 'store/featureFlags/reducer';
import paymentReducer from 'store/payment/reducer';
import qrCodeReducer from 'store/qr-codes/reducer';
import routerReducer from 'store/router/reducer';
import routesReducer from 'store/routes/reducer';
import sdkReducer from 'store/sdk/reducer';
import serviceBookingsReducer from 'store/serviceBookings/reducer';
import serviceContentDeeplinkReducer from 'store/serviceContentDeeplink/reducer';
import serviceContentReducer from 'store/serviceContent/reducer';
import serviceMembershipsReducer from 'store/serviceMemberships/reducer';
import serviceProvidersReducer from 'store/serviceProviders/reducer';
import serviceRegistrationReducer from 'store/serviceRegistration/reducer';
import spreedlyReducer from 'store/add-card/reducer';
import tenantPortalsReducer from 'store/tenantPortals/reducer';
import themeReducer from 'store/theme/reducer';
import transactionsReducer from 'store/transactions/reducer';
import userReducer from 'store/user/reducer';

const rootReducer = combineReducers({
  config: configReducer,
  router: routerReducer,
  featureFlags: featureFlagsReducer,
  user: userReducer,
  building: buildingReducer,
  theme: themeReducer,
  serviceProviders: serviceProvidersReducer,
  serviceContent: serviceContentReducer,
  serviceContentDeeplink: serviceContentDeeplinkReducer,
  errors: errorsReducer,
  serviceRegistration: serviceRegistrationReducer,
  serviceMemberships: serviceMembershipsReducer,
  serviceBookings: serviceBookingsReducer,
  transactions: transactionsReducer,
  availableServices: availableServicesReducer,
  cart: cartReducer,
  routes: routesReducer,
  sdk: sdkReducer,
  spreedly: spreedlyReducer,
  payment: paymentReducer,
  qrCodes: qrCodeReducer,
  tenantPortals: tenantPortalsReducer,
});

export type RootState = StateType<typeof rootReducer>;

export default rootReducer;
